import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ACTION, IMAGE_DEFAULT, ROUTES } from 'consts'
import { useTranslation } from 'react-i18next'
import { compare, formatCash } from 'utils'
import FilterRegion from 'components/filter-region'
//antd
import {
  Row,
  Form,
  Input,
  Button,
  notification,
  Select,
  Spin,
  Table,
  Modal,
  InputNumber,
  Space,
  Checkbox,
} from 'antd'

//icons
import {
  ArrowLeftOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons'

//apis
import { addMenu, updateMenu } from 'apis/menu'
import { getBranches } from 'apis/branch'
import { apiAllProduct } from 'apis/product'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'
import { getCategories } from 'apis/category'

export default function MenuForm() {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const [categories, setCategories] = useState([])
  const [branches, setBranches] = useState([])
  const [products, setProducts] = useState([])
  const [productsSelect, setProductsSelect] = useState([])
  const [productSystem, setProductSystem] = useState([])
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [paramsFilter, setParamsFilter] = useState({ is_souvenir: false, page_size: 500 })

  const columns = [
    {
      width: 100,
      title: 'STT',
      render: (data, record, index) => index + 1,
    },
    {
      title: 'Mã món ăn',
      dataIndex: 'sku',
      sorter: (a, b) => compare(a, b, 'sku'),
    },
    {
      title: 'Tên món ăn',
      dataIndex: 'name',
      sorter: (a, b) => compare(a, b, 'name'),
    },

    {
      width: 110,
      title: 'Chọn',
      render: (text, record, index) => (
        <Checkbox onChange={() => _onCheckProduct(index)} checked={record.is_check} />
      ),
    },
  ]

  const Added = () => (
    <Row wrap={false} align="middle" style={{ color: 'green' }}>
      <div>Đã thêm</div> <CheckOutlined style={{ marginLeft: 5 }} />
    </Row>
  )

  const ModalAddProducts = () => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)
    const [productsId, setProductsId] = useState([])

    const addProducts = () => {
      const productsAdd = products.filter((product) => {
        if (productsId.includes(product.product_id)) {
          const productFind = productsSelect.find((p) => p.product_id === product.product_id)
          return productFind ? false : true
        }
        return false
      })
      setProductsSelect([...productsSelect, ...productsAdd])
      toggle()
    }

    const columns = [
      {
        title: 'Tên món ăn',
        dataIndex: 'name',
      },
      {
        title: 'Mã món ăn',
        dataIndex: 'code',
      },
      {
        title: 'Hình ảnh',
        render: (text, record) =>
          record.image_urls && record.image_urls.length ? (
            <img src={record.image_urls[0]} alt="" style={{ width: 70, height: 70 }} />
          ) : (
            ''
          ),
      },
      {
        title: '',
        render: (text, record) =>
          productsSelect.find((product) => product.product_id === record.product_id) && <Added />,
      },
    ]

    useEffect(() => {
      if (!visible) setProductsId([])
    }, [visible])

    return (
      <>
        {/* <Button onClick={toggle} type="primary">
          Thêm hàng loạt
        </Button> */}
        <Modal
          onOk={addProducts}
          style={{ top: 20 }}
          width="70%"
          onCancel={toggle}
          visible={visible}
          title="Thêm hàng loạt món ăn vào thực đơn"
        >
          <Table
            size="small"
            rowSelection={{
              productsAdd: productsId,
              onChange: (keys) => setProductsId(keys),
            }}
            rowKey="product_id"
            columns={columns}
            dataSource={productsSelect}
            style={{ width: '100%' }}
            scroll={{ y: '55vh' }}
          />
        </Modal>
      </>
    )
  }

  useEffect(() => {
    _getProducts()
  }, [paramsFilter])

  useEffect(() => {
    var _productSelected = [...productsSelect]
    var _productSystem = [...productSystem]
    for (var i = 0; i < _productSelected.length; i++) {
      var index = _productSystem.findIndex((p) => parseInt(p.product_id) === _productSelected[i])
      if (index >= 0) {
        _productSystem[index].is_check = true
      }
    }
    setProductSystem(_productSystem)
  }, [productsSelect])

  const _addOrUpdateMenu = async () => {
    try {
      await form.validateFields()
      // if (productsSelect.length === 0) {
      //   notification.warning({ message: 'Vui lòng chọn ít nhất 1 món ăn' })
      //   return
      // }

      const dataForm = form.getFieldsValue()

      const body = {
        ...dataForm,
        product_ids: productsSelect || [],
      }

      let res

      dispatch({ type: ACTION.LOADING, data: true })
      if (location.state) res = await updateMenu(location.state.menu_id, body)
      else res = await addMenu(body)

      if (res.status === 200) {
        if (res.data.success) {
          notification.success({
            message: `${
              !location.state ? 'Tạo thực đơn thành công' : 'Cập nhật thực đơn thành công'
            }`,
          })
          history.push(ROUTES.MENU)
        } else
          notification.error({
            message:
              res.data.message ||
              `${
                !location.state
                  ? 'Tạo thực đơn thất bại, vui lòng thử lại'
                  : 'Cập nhật thực đơn thất bại, vui lòn thử lại'
              }`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${
              !location.state
                ? 'Tạo thực đơn thất bại, vui lòng thử lại'
                : 'Cập nhật thực đơn thất bại, vui lòn thử lại'
            }`,
        })
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const _addProduct = (product) => {
    const productsSelectNew = [...productsSelect]
    const productFind = productsSelectNew.find((e) => e.product_id === product.product_id)
    if (!productFind) {
      productsSelectNew.push(product)
      setProductsSelect([...productsSelectNew])
    }
  }

  const _onCheckProduct = (index) => {
    var products = [...productSystem]
    var product_selected = [...productsSelect]
    var product = products[index]

    var _indexF = product_selected.findIndex((product_id) => product_id == product.product_id)
    if (_indexF >= 0) {
      setProductsSelect(product_selected.filter((product_id) => product_id != product.product_id))
      products[index].is_check = false
    } else {
      product_selected.push(product.product_id)
      setProductsSelect(product_selected)
      products[index].is_check = true
    }

    setProductSystem(products)
  }

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) setBranches(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _getProducts = async () => {
    try {
      setLoading(true)
      const res = await apiAllProduct(paramsFilter)

      if (res.status === 200) {
        var _products = [...res.data.data]

        if (location.state) {
          for (var i = 0; i < location.state.product_ids.length; i++) {
            var index = _products.findIndex(
              (p) => parseInt(p.product_id) === location.state.product_ids[i]
            )
            if (index >= 0) _products[index].is_check = true
          }
        }
        setProductSystem(_products)
      }
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _getRegions = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {}
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) {
        if (res.data.data && res.data.data.length) {
          if (!location.state) form.setFieldsValue({ country_id: [res.data.data[0].country_id] })

          setCountries(res.data.data)
        }
      }
    } catch (error) {}
  }

  const _getCategories = async () => {
    try {
      const res = await getCategories()
      console.log(res)
      if (res.status === 200) setCategories(res.data.data)
    } catch (error) {}
  }

  useEffect(() => {
    _getCountries()
    _getRegions()
    _getBranches()
    _getProducts()
    _getCategories()

    if (location.state) {
      setProductsSelect(location.state.product_ids)
    }
  }, [])

  useEffect(() => {
    if (location.state) form.setFieldsValue({ ...location.state })
  }, [])

  return (
    <div className="card-container">
      <div style={{ borderBottom: '0.75px solid #BBBCBD', paddingBottom: 15 }}>
        <Row
          align="middle"
          onClick={() => history.push(ROUTES.MENU)}
          style={{ cursor: 'pointer', width: 'max-content' }}
        >
          <ArrowLeftOutlined style={{ fontSize: 16 }} />
          <h3 style={{ marginBottom: 0, fontWeight: 700, marginLeft: 7 }}>
            {location.state ? 'Cập nhật thực đơn' : 'Tạo thực đơn'}
          </h3>
        </Row>
      </div>
      <br />

      <Form layout="vertical" form={form}>
        <Row wrap={false} justify="space-between">
          <Form.Item
            rules={[{ required: true, message: 'Vui lòng nhập tên thực đơn' }]}
            name="name"
            label="Tên thực đơn"
            style={{ width: '100%' }}
          >
            <Input placeholder="Nhập tên thực đơn" style={{ width: '98%' }} />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: 'Vui lòng nhập độ ưu tiên' }]}
            name="priority"
            label="Độ ưu tiên hiển thị"
            style={{ width: '30%' }}
          >
            <InputNumber placeholder="Ưu tiên cao sẽ hiển thị bên trên" style={{ width: '98%' }} />
          </Form.Item>
        </Row>

        <Row wrap={false}>
          <Form.Item
            rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
            label="Quốc gia áp dụng"
            name="country_ids"
          >
            <Select
              mode="multiple"
              style={{ width: 350, marginRight: 5 }}
              allowClear
              optionFilterProp="children"
              showSearch
              placeholder="Chọn quốc gia"
            >
              {countries.map((country, index) => (
                <Select.Option key={index} value={country.country_id}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: 'Vui lòng chọn khu vực' }]}
            label="Khu vực áp dụng"
            name="region_ids"
          >
            <Select
              mode="multiple"
              style={{ width: 350, marginRight: 5 }}
              allowClear
              optionFilterProp="children"
              showSearch
              placeholder="Chọn khu vực"
            >
              {regions.map((region, index) => (
                <Select.Option key={index} value={region.region_id}>
                  {region.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: 'Vui lòng chọn chi nhánh' }]}
            name="branch_ids"
            label="Chi nhánh áp dụng"
          >
            <Select
              mode="multiple"
              placeholder="Chọn chi nhánh"
              allowClear
              showSearch
              optionFilterProp="children"
              style={{ width: 350, marginRight: 5 }}
            >
              {branches.map((branch, index) => (
                <Select.Option value={branch.branch_id} key={index}>
                  {branch.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Row>

        <Form.Item
          rules={[{ required: true, message: 'Vui lòng chọn phân loại món' }]}
          label="Phân loại món cấp 1"
          name="category_ids"
        >
          <Select
            mode="multiple"
            style={{ width: 705, marginRight: 5 }}
            allowClear
            optionFilterProp="children"
            showSearch
            placeholder="Chọn phân loại món"
          >
            {categories.map((category, index) => (
              <Select.Option key={index} value={category.category_id}>
                {category.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Row wrap={false}>
          {/* <FilterRegion
            width_size={400}
            setParamsFilter={setParamsFilter}
            paramsFilter={paramsFilter}
          /> */}
          {/* <Select
            notFoundContent={loading ? <Spin size="small" /> : null}
            dropdownClassName="dropdown-select-search-product"
            allowClear
            showSearch
            clearIcon={<CloseOutlined style={{ color: 'black' }} />}
            suffixIcon={<SearchOutlined style={{ color: 'black', fontSize: 15 }} />}
            style={{ width: '100%', marginRight: 10 }}
            placeholder="Thêm món ăn vào thực đơn"
            dropdownRender={(menu) => <div>{menu}</div>}
            value="Thêm món ăn vào thực đơn"
          >
            {products.map((data, index) => (
              <Select.Option value={data.name} key={index}>
                <Row
                  align="middle"
                  wrap={false}
                  style={{ padding: '7px 13px' }}
                  onClick={() => {
                    if (data.category_ids && data.category_ids.length) _addProduct(data)
                    else
                      notification.warning({
                        key: 'noti-category',
                        message: 'Vui lòng thêm ít nhất 1 phân loại món cho sản phẩm này',
                        description: (
                          <a
                            target="_blank"
                            href={ROUTES.PRODUCT_UPDATE + `?product_id=${data.code}`}
                          >
                            <Button
                              onClick={(e) => e.stopPropagation()}
                              type="primary"
                              size="small"
                            >
                              Thêm phân loại món
                            </Button>
                          </a>
                        ),
                      })
                  }}
                >
                  <img
                    src={data.image_urls[0] ? data.image_urls[0] : IMAGE_DEFAULT}
                    alt=""
                    style={{
                      minWidth: 40,
                      minHeight: 40,
                      maxWidth: 40,
                      maxHeight: 40,
                      objectFit: 'cover',
                    }}
                  />

                  <div style={{ width: '100%', marginLeft: 15 }}>
                    <Row wrap={false} justify="space-between">
                      <div>
                        <span
                          style={{
                            maxWidth: '100%',
                            marginBottom: 0,
                            fontWeight: 600,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                            display: '-webkit-box',
                          }}
                        >
                          {data.name}
                        </span>
                        {productsSelect.find(
                          (product) => product.product_id === data.product_id
                        ) && <Added />}
                      </div>
                      {data.category_ids && data.category_ids.length ? (
                        ''
                      ) : (
                        <Link
                          target="_blank"
                          to={{
                            pathname: ROUTES.PRODUCT_UPDATE + `?product_id=${data.code}`,
                            state: data,
                          }}
                        >
                          <Button onClick={(e) => e.stopPropagation()} type="primary" size="small">
                            Thêm phân loại món
                          </Button>
                        </Link>
                      )}
                    </Row>
                  </div>
                </Row>
              </Select.Option>
            ))}
          </Select> */}
          <ModalAddProducts />
        </Row>

        {/* <Table
          style={{ width: '100%', marginTop: 5 }}
          size="small"
          pagination={false}
          columns={columns}
          dataSource={productSystem}
          scroll={{ y: 500 }}
        /> */}
        <br />
        <Button onClick={_addOrUpdateMenu} type="primary" size="large" style={{ width: 120 }}>
          {location.state ? t('common.save') : t('common.create')}
        </Button>
      </Form>
    </div>
  )
}
